<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 192 192">
    <path d="M96,0C43,0,0,43,0,96s43,96,96,96s96-43,96-96S149,0,96,0z M79,152l-49.5-49.5l17-17L79,118l69-69l17,17L79,152z">
    </path>
  </svg>
</template>
